import { compose } from 'redux'
import View from './AndroidAppBadge'
import { connect } from 'react-redux'
import { downloadAndroidApp } from '../../../../store/modules/mobileApps'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const mapDispatchToProps = dispatch => ({
  downloadAndroidApp: compose(dispatch, downloadAndroidApp),
})

const AndroidAppBadge = connect(mapStateToProps, mapDispatchToProps)(View)

export default AndroidAppBadge
